import axios, { AxiosError } from 'axios'
import { ActionWithPayload, AppDispatch, RootState } from '../store'

const PROMO_CODE_MODIFY_REQUEST = 'PROMO_CODE_MODIFY_REQUEST'
const PROMO_CODE_MODIFY_SUCCESS = 'PROMO_CODE_MODIFY_SUCCESS'
const PROMO_CODE_MODIFY_ERROR = 'PROMO_CODE_MODIFY_ERROR'
const PROMO_CODE_MODIFY_RESET = 'PROMO_CODE_MODIFY_RESET'

interface PromoCodesRequestAction {
  type: typeof PROMO_CODE_MODIFY_REQUEST
}

interface PromoCodesSuccessAction {
  type: typeof PROMO_CODE_MODIFY_SUCCESS
  payload: boolean
}

interface PromoCodesErrorAction {
  type: typeof PROMO_CODE_MODIFY_ERROR
  payload: string
}

type PromoCodesActionTypes =
  | PromoCodesRequestAction
  | PromoCodesSuccessAction
  | PromoCodesErrorAction

export enum PromoCodeMethod {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export const modifyPromoCode =
  (promoCode: PromoCode, method: PromoCodeMethod) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({
        type: PROMO_CODE_MODIFY_REQUEST,
        payload: method,
      })

      const {
        userLogin: { userInfo },
      } = getState()
      const token = (userInfo as User).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.post(
        `/api/promoCodes/modify`,
        { promoCode, method },
        config
      )

      dispatch({
        type: PROMO_CODE_MODIFY_SUCCESS,
        payload: data,
      })
    } catch (err: unknown) {
      let errorMessage = 'An unexpected error occurred'

      if (axios.isAxiosError(err)) {
        const error = err as AxiosError

        if (error.response && error.response.data) {
          errorMessage = (error.response.data as { message: string }).message
        } else {
          errorMessage = error.message
        }
      } else if (err instanceof Error) {
        // This will be true for any instance of Error
        errorMessage = err.message
      }

      dispatch({
        type: PROMO_CODE_MODIFY_ERROR,
        payload: errorMessage,
      })
    }
  }

interface InitialState {
  code: undefined | PromoCode | string
  error: string
  loading: boolean
  method: PromoCodeMethod | undefined
  success: boolean
}

const initialState: InitialState = {
  error: '',
  loading: false,
  method: undefined,
  success: false,
  code: undefined,
}

export const promoCodeModifyReducer = (
  state = initialState,
  action: ActionWithPayload<PromoCodesActionTypes>
) => {
  switch (action.type) {
    case PROMO_CODE_MODIFY_REQUEST:
      return {
        ...state,
        error: '',
        loading: true,
        success: false,
        method: action.payload,
      }
    case PROMO_CODE_MODIFY_SUCCESS:
      return {
        ...state,
        error: '',
        success: true,
        loading: false,
        code: action.payload,
      }
    case PROMO_CODE_MODIFY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      }
    case PROMO_CODE_MODIFY_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
